<template>
  <div class="header-log">
    <router-link to="/"><h1><span>MON</span>PERMIS.<span>FR</span></h1></router-link>
    <img src="../assets/images/logoMonPermis.png" alt="" />
  </div>

  <div class="page">
    <div class="card">
      <div class="avatar" :class="{ error: statut === 'introuvable' }">
        <svg v-if="loading" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <circle cx="12" cy="12" r="9" stroke-dasharray="40" stroke-dashoffset="10" stroke-linecap="round"/>
        </svg>
        <svg v-else-if="statut === 'ok' || statut === 'deja_utilise'" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M20 6L9 17l-5-5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <svg v-else width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>

      <template v-if="loading">
        <h2 class="title">Émargement en cours...</h2>
      </template>

      <template v-else-if="statut === 'ok'">
        <h2 class="title">Merci !</h2>
        <p class="subtitle">
          {{ nbEmarges }} cours {{ nbEmarges > 1 ? 'ont' : 'a' }} bien été émargé{{ nbEmarges > 1 ? 's' : '' }}.
        </p>
      </template>

      <template v-else-if="statut === 'deja_utilise'">
        <h2 class="title">Déjà fait</h2>
        <p class="subtitle">Ce lien a déjà été utilisé. Vos cours ont déjà été émargés.</p>
      </template>

      <template v-else>
        <h2 class="title">Lien invalide</h2>
        <p class="subtitle">Ce lien d'émargement n'est plus valide. Contactez votre auto-école si besoin.</p>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      statut: null,
      nbEmarges: 0,
    };
  },

  mounted() {
    window.api
      .get("/emargement/valider/" + this.$route.params.token)
      .then((response) => {
        this.statut = response.data.statut;
        this.nbEmarges = response.data.nbEmarges || 0;
        this.loading = false;
      })
      .catch(() => {
        this.statut = "introuvable";
        this.loading = false;
      });
  },
};
</script>

<style scoped>
div.header-log {
  display: flex;
  border-bottom: 1px solid #E2E8F0;
  justify-content: space-between;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;
  background-color: white;
}

div.header-log h1 {
  font-weight: bold;
  margin: 0;
}

div.header-log a {
  text-decoration: none;
  color: #1e293b;
}

div.header-log span {
  color: #6899f5;
}

div.header-log img {
  width: 60px;
  height: 60px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.page {
  width: 100%;
  min-height: calc(100vh - 82px);
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
  padding: 20px;
}

.card {
  width: 420px;
  max-width: 100%;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 40px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
}

.avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #eff6ff;
  color: #3b82f6;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.avatar.error {
  background: #fef2f2;
  color: #ef4444;
}

.title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 6px;
}

.subtitle {
  font-size: 13px;
  color: #64748b;
  margin: 0;
}
</style>
